export default __webpack_public_path__ + "static/media/old_logo.306575bee7e6d55ef650ee3647cc77a0.svg";